export enum CardTypeEnum {
    Service = 0,
    Money = 1,
    Meal = 2
}
